import {
  FutureTimeframeDays,
  LastCompletedVisitFilterOperator,
  PastTimeframeDays,
  VisitFilterDirection,
  VisitFilterOperator,
} from './_types';

export interface VisitFilterSelectOption<T extends string | number> {
  label: string;
  value: T;
}

export const VISIT_FILTER_OPERATORS: VisitFilterSelectOption<VisitFilterOperator>[] =
  [
    { label: 'More than', value: 'gt' },
    { label: 'Less than', value: 'lt' },
    { label: 'Equal to', value: 'eq' },
  ];

export const LAST_COMPLETED_VISIT_OPERATORS: VisitFilterSelectOption<LastCompletedVisitFilterOperator>[] =
  [
    { label: 'More than', value: 'gt' },
    { label: 'Less than', value: 'lt' },
  ];

export const COMPLETED_VISIT_TIMEFRAME_OPTIONS: VisitFilterSelectOption<PastTimeframeDays>[] =
  [
    { label: 'Last 7 days', value: 7 },
    { label: 'Last 14 days', value: 14 },
    { label: 'Last 30 days', value: 30 },
  ];

export const STANDARD_PAST_TIMEFRAME_OPTIONS: VisitFilterSelectOption<PastTimeframeDays>[] =
  [
    { label: 'Last 7 days', value: 7 },
    { label: 'Last 30 days', value: 30 },
    { label: 'Last 60 days', value: 60 },
    { label: 'Last 90 days', value: 90 },
  ];

export const UPCOMING_VISIT_TIMEFRAME_OPTIONS: VisitFilterSelectOption<FutureTimeframeDays>[] =
  [
    { label: 'Next 7 days', value: 7 },
    { label: 'Next 30 days', value: 30 },
    { label: 'Next 60 days', value: 60 },
    { label: 'Next 90 days', value: 90 },
  ];

export const TIMEFRAME_OPTIONS_BY_DIRECTION: Record<
  VisitFilterDirection,
  VisitFilterSelectOption<PastTimeframeDays | FutureTimeframeDays>[]
> = {
  past: STANDARD_PAST_TIMEFRAME_OPTIONS,
  future: UPCOMING_VISIT_TIMEFRAME_OPTIONS,
};
